import request from '@/utils/request';
import { PromptSuggestion } from './PromptSuggestion';

/**
 * Get the chatbot prompt suggestions to display on a page.
 * @param {string} pageRoute - The route the user is on.
 * @returns {Promise<PromptSuggestion[]>} The suggestions, empty on failure.
 */
export async function getPromptSuggestions(pageRoute) {
  if (!pageRoute) {
    return [];
  }

  const response = await request.get(
    `/api/prompt/suggestions?pageRoute=${encodeURIComponent(pageRoute)}`,
    {
      // Suggestions are a supplemental feature, so fail silently instead of toasting.
      errorMessage: null,
    }
  );

  const suggestions = response?.data ?? [];

  return suggestions.map(suggestion => new PromptSuggestion(suggestion));
}
